import { render } from "./SearchCenter.layout.vue?vue&type=template&id=bb6a04a8"
import script from "./SearchCenter.layout.vue?vue&type=script&lang=js"
export * from "./SearchCenter.layout.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/SearchCenter.layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb6a04a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb6a04a8', __exports__)) {
    console.log('reload')
    api.reload('bb6a04a8', __exports__)
  }
  
  module.hot.accept("./SearchCenter.layout.vue?vue&type=template&id=bb6a04a8", () => {
    console.log('re-render')
    api.rerender('bb6a04a8', render)
  })

}


export default __exports__